export default __webpack_public_path__ + "static/swizec-4399468fecf470a4abfaebbe1ad45213.png";